/*!-----------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.5.3(793ede49d53dba79d39e52205f16321278f5183c)
 * Released under the MIT license
 * https://github.com/Microsoft/vscode/blob/master/LICENSE.txt
 *-----------------------------------------------------------*/

define("vs/base/common/worker/simpleWorker.nls.de", {
	"vs/base/common/errors": [
		"{0}. Fehlercode: {1}",
		"Berechtigung verweigert (HTTP {0})",
		"Berechtigung verweigert",
		"{0} (HTTP {1}: {2})",
		"{0} (HTTP {1})",
		"Unbekannter Verbindungsfehler ({0})",
		"Es ist ein unbekannter Verbindungsfehler aufgetreten. Entweder besteht keine Internetverbindung mehr, oder der verbundene Server ist offline.",
		"{0}: {1}",
		"Ein unbekannter Fehler ist aufgetreten. Weitere Details dazu finden Sie im Protokoll.",
		"Systemfehler ({0})",
		"Ein unbekannter Fehler ist aufgetreten. Weitere Details dazu finden Sie im Protokoll.",
		"{0} ({1} Fehler gesamt)",
		"Ein unbekannter Fehler ist aufgetreten. Weitere Details dazu finden Sie im Protokoll.",
		"Nicht implementiert",
		"ungültiges Argument: {0}",
		"ungültiges Argument",
		"ungültiger Status: {0}",
		"ungültiger Status",
		"Eine erforderliche Datei konnte nicht geladen werden. Entweder sind Sie nicht mehr mit dem Internet verbunden oder der verbundene Server ist offline. Aktualisieren Sie den Browser, und wiederholen Sie den Vorgang.",
		"Fehler beim Laden einer erforderlichen Datei. Bitte starten Sie die Anwendung neu, und versuchen Sie es dann erneut. Details: {0}",
	],
	"vs/base/common/keyCodes": [
		"Windows",
		"Steuerelement",
		"Umschalttaste",
		"Alt",
		"Befehl",
		"Windows",
		"Strg",
		"Umschalttaste",
		"Alt",
		"Befehl",
		"Windows",
	],
	"vs/base/common/severity": [
		"Fehler",
		"Warnung",
		"Info",
	]
});